/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from "react";
import { PreviewImage } from "./PreviewImage";
import { serverConfig } from "../../../../utils/config";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { CurrencyContext } from "../../../../contexts/AppContext";
import { ConvertedDeviseWithMoneySign } from "../../../../utils/CurrencyConvertFunction";
import { IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { CountryService } from "../../../Admin/Countries/services/EquipmentCountry";

const Env = serverConfig;

const useStyles = makeStyles(() =>
    createStyles({
        previewPhotos: {
            display: "block",
            borderRadius: "4px",
            width: "150px",
            height: "160px",
            marginBottom: "5px",
        },
        button: {
            backgroundColor: "#890608",
            borderRadius: 100,
            height: 20,
            marginBottom: "5px",
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        popupBody: {
            position: "relative",
            padding: "0px",
        },
        iconButton: {
            position: "absolute",
            right: "-4px",
            top: "-4px",
            zIndex: 10,
            transition: "transform 0.15s ease-in-out",
            "&:hover": {
                transform: "scale3d(1.25, 1.25, 1)",
                opacity: 1,
            },
        },
        closeButton: {
            opacity: 0.2,
            transition: "opacity .5s ease-in-out, background .2s ease-in-out",
            background: "#890608",
            borderRadius: "50%",
            color: "white",
            border: "solid 1px white",
            "&:hover": {
                opacity: 1,
                background: "#EA7606",
            },
        },
        "@global": {
            ".MuiTypography-body2": {
                fontSize: 12,
                color: "#EA7606",
            },
            ".MuiTypography-caption": {
                fontSize: 10,
            },
            ".MuiTypography-subtitle1": {
                fontSize: 13,
                fontWeight: 800,
            },
        },
    })
);

export const PlaceInfo = (props: any) => {
    const [commissionFee, setCommissionFee] = React.useState<number>(0);
    const [priceConvertedInitial, setPriceConvertedInitial] =
        React.useState<number>(0);

    const classes = useStyles();

    const previewPhotos = props.datas.propertyData[0].photos.map(
        (photo: any) => {
            if (photo.filename) {
                return {
                    id: photo._id,
                    url: `${Env.ApiRoot}/images/properties/${photo.filename}`,
                    filename: photo.filename,
                };
            }
            return {
                id: photo._id,
                url: "",
            };
        }
    );

    const { t } = useTranslation();

    const history = useHistory();

    const handleView = () => {
        history.push(`/details-announce-${props.datas._id}`);
    };

    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;

    const countryService = new CountryService();

    React.useEffect(() => {
        let percentage = 0;
        if (props.datas.propertyData[0].propertyTypeData[0].name === "Hôtel") {
            countryService
                .getSpecialFeeByPropertyType(
                    props.datas.propertyData[0].propertyTypeData[0].name
                )
                .then((response) => {
                    if (response.success) {
                        percentage = response.data
                            ? response.data.percentageTraveller
                            : 0;
                        setCommissionFee(percentage);
                        const basePrice = props.datas.price;
                        const normalBasePrice = (
                            basePrice +
                            basePrice * (percentage / 100)
                        ).toFixed(2);
                        ConvertedDeviseWithMoneySign(
                            props.datas.devise || "eur",
                            currency,
                            normalBasePrice
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    } else {
                        ConvertedDeviseWithMoneySign(
                            props.datas.devise || "eur",
                            currency,
                            props.datas.price
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    }
                });
        } else {
            countryService
                .getCommissionFeeByCountryAndCityId(
                    props.datas?.propertyData[0]?.address?.country?.name,
                    props.datas?.propertyData[0]?.address?.city?.name
                )
                .then((respCom) => {
                    /*console.log("PlaceInfo.tsx - countryService.getCommissionFeeByCountryAndCityId arguments:", {
                        countryName: props.datas?.propertyData[0]?.address?.country?.name,
                        cityName: props.datas?.propertyData[0]?.address?.city?.name,
                    });*/
                    if (respCom.success) {
                        percentage = respCom.data ? respCom.data.percentage : 0;
                        setCommissionFee(percentage);
                        const basePrice = props.datas.price;
                        const normalBasePrice = (
                            basePrice +
                            basePrice * (percentage / 100)
                        ).toFixed(2);
                        ConvertedDeviseWithMoneySign(
                            props.datas.devise || "eur",
                            currency,
                            normalBasePrice
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    } else {
                        ConvertedDeviseWithMoneySign(
                            props.datas.devise || "eur",
                            currency,
                            props.datas.price
                        )
                            .then((value: any): any =>
                                setPriceConvertedInitial(value)
                            )
                            .catch((error) => console.log(error));
                    }
                });
        }
    }, [currency, props.datas.devise, props.datas.price]);

    return (
        <>
            <div className={classes.popupBody}>
                <div className={classes.iconButton}>
                    <IconButton size="small" onClick={props.handleCloseButton}>
                        <CloseRoundedIcon className={classes.closeButton} />
                    </IconButton>
                </div>
                <Grid container direction="column">
                    <Grid className={classes.previewPhotos} item>
                        <PreviewImage photos={previewPhotos} />
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" justifyContent="center">
                            <Button
                                onClick={handleView}
                                className={classes.button}
                            >
                                {t("placeInfo.view")}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">
                            {props.datas.propertyData[0].propertyTypeData[0]
                                .label
                                ? t(
                                      props.datas.propertyData[0]
                                          .propertyTypeData[0].label
                                  )
                                : props.datas.propertyData[0]
                                      .propertyTypeData[0].name}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            {props.datas.propertyData[0].name.substring(0, 20)}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        container
                        direction="row-reverse"
                        justifyContent="space-between"
                    >
                        <Grid item>
                            <Typography variant="caption">
                                <span style={{ color: "#EA7606" }}>
                                    {priceConvertedInitial !== 0
                                        ? priceConvertedInitial
                                        : props.datas.price}
                                </span>
                                / {t("label.nuitee")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};
